module.exports = __webpack_public_path__ + "img/section6ModelZh.2a2c5d8d.png";